import React from 'react';
import PropTypes from 'prop-types';
import 'normalize.css/normalize.css';
import { Provider } from 'rebass';
import Breakpoint from '../app/components/breakpoint';
import Seo from '../app/components/seo';
import Desktop from './desktop';
import Mobile from './mobile';
import theme from '../app/themes';
import getSeoForPage from '../app/data/seo/get_seo_for_page';
import './base.css';

const Template = (props) => (
  <Provider theme={theme}>
    <Seo {...getSeoForPage(props)} />
    <Breakpoint mobile>
      <Mobile {...props} />
    </Breakpoint>
    <Breakpoint>
      <Desktop {...props} />
    </Breakpoint>
  </Provider>
);

Template.propTypes = {
  children: PropTypes.func,
};

Template.defaultProps = {
  children: null,
};

export default Template;



// WEBPACK FOOTER //
// ./src/layouts/index.js